import { SvgIcon, SvgIconProps } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';

export const createIconFromSvg = (iconComponent: React.ComponentType, viewBox = '0 0 24 24'): SvgIconComponent => {
  const comp = (props: SvgIconProps): JSX.Element => {
    return (
      <SvgIcon
        {...props}
        component={iconComponent}
        viewBox={viewBox}
      />
    );
  };

  comp.muiName = 'custom';

  return comp;
};
